import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProfessionsEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
class ProfessionsEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    as_Input_PerformerDisplayMode: MdsLax<InstanceType<typeof SearchSelect>>;

    isValid(): boolean {
        if (!this.as_Input_PerformerDisplayMode.getValue()) return false;

        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.Professions;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProfessionsEditorV2);
